import { METADATA } from '@/helpers/metadata';
import { GET_BLOG_ARTICLES } from '../types/blogTypes';

const initialState = {
  blogArticles: { ...METADATA.default, data: null },
};

const blogReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BLOG_ARTICLES.REQUEST:
      return {
        ...state,
        activityList: { ...state.blogArticles, ...METADATA.request },
      };
    case GET_BLOG_ARTICLES.SUCCESS:
      return {
        ...state,
        blogArticles: { ...METADATA.success, data: action.payload },
      };
    case GET_BLOG_ARTICLES.FAILURE:
      return {
        ...state,
        blogArticles: {
          ...state.blogArticles,
          ...METADATA.error,
          error: action.error,
        },
      };

    default:
      return state;
  }
};

export default blogReducer;
